var _defs, _rect, _rect2, _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ceb39404f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.00390625 L 374.933594 0.00390625 L 374.933594 374.996094 L 0 374.996094 Z M 0 0.00390625 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M -0.0664062 0 L 374.933594 0 L 374.933594 375 L -0.0664062 375 Z M -0.0664062 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ceb39404f1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, -0.0672243, 0.00431829)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00109071 -0.000549382 L 500.079249 -0.000549382 L 500.079249 499.989067 L 0.00109071 499.989067 Z M 0.00109071 -0.000549382 ",
    stroke: "#000000",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.704376, 0.257592, -0.257592, 0.704376, 104.868264, 148.287677)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00105847 10.000452 L 241.936875 9.999706 ",
    stroke: "#ffffff",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.704376, -0.257592, 0.257592, 0.704376, 99.71641, 210.604923)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000908458 9.999979 L 241.936725 10.000724 ",
    stroke: "#ffffff",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.a4a72be253d5114536069fb28ecbb750.svg";
export { ForwardRef as ReactComponent };